var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquigglyLineLeftBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 209,
    viewBox: "0 0 238 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.769 209C232.769 209 238.858 161.03 223.95 137.184C208.375 112.274 181.922 116.86 160.251 98.2843C129.021 71.5138 152.569 64.5814 122.522 36.443C100.28 15.6137 88.0596 4.76969 57.8439 4.02628C35.8782 3.48585 24.8407 11.3243 6.3953 23.4763C-20.6271 41.279 -21.8332 60.9177 -47.0133 81.3278C-86.2688 113.147 -170 119.23 -170 119.23",
    stroke: "#43D079",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquigglyLineLeftBottom);
export default __webpack_public_path__ + "static/media/squiggly-line-left-bottom.5a6f51107c60b259cf62deb2222faa12.svg";
export { ForwardRef as ReactComponent };